<template>
  <div class="canva-map-container" ref="canvaMap">
    <slot v-if="mapReady"> </slot>
  </div>
</template>

<script>
/* eslint-disable */
import resizeMixin from "@/mixins/resize";
export default {
  name: "CanvaMap",
  mixins: [resizeMixin],
  props: {
    /**
     * 地图的分辨率。这个参数表示地图中一个像素对应的实际长度（以米为单位）。在子中，分辨率为0.05米/像素，意味着每个像素代表地图中0.05米的实际长度。
     */
    resolution: {
      type: Number,
      default: 0.05,
    },
    /**地图的原点坐标。这是一个包含三个值的数组，表示地图坐标系的原点在世界坐标系中置。在这个例子中，原点坐标为(-18.6, -17.0, 0.0)，表示地图坐标系的原点位于世界坐标系中的(-1
     *-17.0)位置，并且Z轴的高度为0.0。
     */
    origin: {
      type: Array,
      default: () => [0, 0, 0],
    },
    originX: {
      //机器人地图初始点X坐标
      type: Number,
      default: 0,
    },
    originY: {
      //机器人地图初始点Y坐标
      type: Number,
      default: 0,
    },
    mapSrc: {
      //地图图片
      type: String,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      mapReady: false,
      canvasRatio: 0, //画布宽高比
      mapImage: {
        //地图图片信息
        image: "",
        whRatio: 0, // 宽高比
        originWidth: 0,
        originHeight: 0,
        width: 0,
        height: 0,
        scale: 1, // 缩放比
        x: 0,
        y: 0,
      },
    };
  },
  methods: {
    init() {
      var zr = zrender.init(this.$refs.canvaMap);
      this.$zr = zr;
      const canvasWidth = zr.getWidth();
      const canvasHeight = zr.getHeight();
      // 画布宽高比
      const canvasRatio = canvasWidth / canvasHeight;
      this.canvasRatio = canvasRatio;
      this.initMap();
    },
    initMap() {
      if (!this.mapSrc) {
        this.emitMapReady();
        return;
      }
      const canvasRatio = this.canvasRatio;
      const canvasWidth = this.$zr.getWidth();
      const canvasHeight = this.$zr.getHeight();
      // 创建图片对象

      const mapImg = new Image();
      mapImg.src = this.mapSrc;
      mapImg.onload = () => {
        this.mapImage.originWidth = mapImg.width;
        this.mapImage.originHeight = mapImg.height;
        this.mapImage.image = mapImg;
        // 图片的宽高比
        var whRatio = (this.mapImage.whRatio = mapImg.width / mapImg.height);

        const originalHeight = mapImg.height;
        // 图片相对于画布的尺寸进行调整
        // 如果图片的宽高比大于画布的宽高比

        if (whRatio > canvasRatio) {
          mapImg.width = canvasWidth;
          mapImg.height = mapImg.width / whRatio;
        } else {
          mapImg.height = canvasHeight;
          mapImg.width = mapImg.height * whRatio;
        }
        // 对图片的宽高进行调整
        this.mapImage.width = mapImg.width;
        this.mapImage.height = mapImg.height;
        this.mapImage.scale = this.mapImage.height / originalHeight;

        let imgWidth = this.mapImage.width;
        let imgHeight = this.mapImage.height;

        var deltaY = 0; //地图图片在canvas的y坐标
        var deltaX = 0; //地图图片在canvas的x坐标

        if (imgWidth < canvasWidth) {
          deltaX = (canvasWidth - imgWidth) / 2;
        }
        if (imgHeight < canvasHeight) {
          deltaY = (canvasHeight - imgHeight) / 2;
        }
        this.mapImage.x = deltaX;
        this.mapImage.y = deltaY;
        var img = new zrender.Image({
          style: {
            x: deltaX,
            y: deltaY,
            image: mapImg,
          },
        });
        this.$zr.add(img);
        this.emitMapReady();
      };
    },
    emitMapReady() {
      this.mapReady = true;
      this.$emit("mapReady");
    },
    initResizeHandler() {
      this.$_resizeHandler = () => {
        this.resize();
      };
    },
    resize() {
      this.$nextTick(() => {
        if (this.$zr) {
          this.$zr.resize();
          this.mapReady = false;
          this.$zr.clear();
          this.initMap();
        }
      });
    },
    //更新地图
    updateMapImage() {
      if (this.$zr) {
        const zr = this.$zr;
        const canvasWidth = zr.getWidth();
        const canvasHeight = zr.getHeight();
        // 画布宽高比
        const canvasRatio = canvasWidth / canvasHeight;
        this.canvasRatio = canvasRatio;
        const mapImage = this.mapImage;
        const mapImg = mapImage.image;
        // 图片的宽高比
        var whRatio = this.mapImage.whRatio;

        const originWidth = mapImage.originWidth;
        const originalHeight = mapImage.originHeight;
        // 图片相对于画布的尺寸进行调整
        // 如果图片的宽高比大于画布的宽高比

        if (whRatio > canvasRatio) {
          mapImg.width = canvasWidth;
          mapImg.height = originWidth / whRatio;
        } else {
          mapImg.height = canvasHeight;
          mapImg.width = originalHeight * whRatio;
        }
        // 对图片的宽高进行调整
        this.mapImage.width = mapImg.width;
        this.mapImage.height = mapImg.height;
        this.mapImage.scale = this.mapImage.height / originalHeight;

        let imgWidth = this.mapImage.width;
        let imgHeight = this.mapImage.height;
        var deltaY = 0;
        var deltaX = 0;
        if (imgWidth < canvasWidth) {
          deltaX = (canvasWidth - imgWidth) / 2;
        }
        if (imgHeight < canvasHeight) {
          deltaY = (canvasHeight - imgHeight) / 2;
        }
        this.mapImage.x = deltaX;
        this.mapImage.y = deltaY;
      }
    },
    //机器人坐标转地图坐标
    robotPositionToMapPosition(position) {
      if (Array.isArray(position)) {
        let x = position[0] || 0;
        let y = position[1] || 0;
        x = Number(x);
        y = Number(y);

        let mapScale = this.mapImage.scale;
        let mapImageX = this.mapImage.x;
        let mapImageY = this.mapImage.y;
        const originX = this.originX;
        const originY = this.originY;
        // x = x * mapScale + mapImageX;
        // y = y * mapScale + mapImageY;
        x = (x + originX) * mapScale + mapImageX;
        y = (y + originY) * mapScale + mapImageY;

        return [x, y];
      } else {
        return null;
      }
    },
    //地图坐标转机器人坐标
    mapPositionToRobotPosition(position) {
      if (Array.isArray(position)) {
        let x = position[0] || 0;
        let y = position[1] || 0;
        let mapScale = this.mapImage.scale;
        let mapImageX = this.mapImage.x;
        let mapImageY = this.mapImage.y;

        x = (x - mapImageX) / mapScale;
        y = (y - mapImageY) / mapScale;
        return [x, y];
      } else {
        return null;
      }
    },
    rosToCanvasMap(position) {
      if (Array.isArray(position)) {
        let x = position[0] || 0;
        let y = position[1] || 0;
        x = Number(x);
        y = Number(y);

        let mapScale = this.mapImage.scale;
        let mapImageX = this.mapImage.x;
        let mapImageY = this.mapImage.y;
        let mapImageHeight = this.mapImage.height;

        const rosMapOriginInCanvas = [mapImageX, mapImageY + mapImageHeight];

        x = x + rosMapOriginInCanvas[0];
        y = y + rosMapOriginInCanvas[1];

        return [x, y];
      } else {
        return null;
      }
    },
    wordToCanvasMap(position) {
      if (Array.isArray(position)) {
        let x = position[0] || 0;
        let y = position[1] || 0;
        x = Number(x);
        y = Number(y);

        let mapScale = this.mapImage.scale;
        let mapImageX = this.mapImage.x;
        let mapImageY = this.mapImage.y;
        let mapImageHeight = this.mapImage.height;

        let rosMapPosition = this.worldToRosMap(x, y);
        console.log(rosMapPosition, "rosMapPosition");
        const rosMapOriginInCanvas = [mapImageX, mapImageY + mapImageHeight];

        x = rosMapPosition[0] * mapScale - rosMapOriginInCanvas[0];
        y = rosMapOriginInCanvas[1] - rosMapPosition[1] * mapScale;

        return [x, y];
      } else {
        return null;
      }
    },
    /**
     * 地图坐标（机器人坐标）转世界坐标
     * @param {*} mapX
     * @param {*} mapY
     * @returns
     */
    rosMapToWorld(mapX, mapY) {
      let originX = this.originX;
      let originY = this.originY;
      wx = originX + (mapX + 0.5) * this.resolution; //+0.5是为了取栅格中点坐标
      wy = originY + (mapY + 0.5) * this.resolution;
      return [wx, wy];
    },
    /**
     * 世界坐标转地图坐标
     * @param {*} wx
     * @param {*} wy
     * @returns
     */
    worldToRosMap(wx, wy) {
      let originX = this.origin[0];
      let originY = this.origin[1];
      if (wx < originX || wy < originY) return [originX, originY];
      let mapX = (wx - originX) / this.resolution;
      let mapY = (wy - originY) / this.resolution;
      return [mapX, mapY];
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    mapSrc() {
      if (this.$zr) {
        this.mapReady = false;
        this.$zr.clear();
      }

      this.initMap();
    },
  },
  beforeDestroy() {
    if (this.$zr) {
      // zrender.dispose(this.$zr);
    }
  },
  destroyed() {
    if (this.$zr) {
      zrender.dispose(this.$zr);
    }
  },
};
</script>

<style lang="scss" scoped>
.canva-map-container {
  height: 100%;
  width: 100%;
}
</style>>
